import { mainApi } from '..';
import type { ChartData, ChartType, FetchChartDataParams } from '@/features/analytics/types/analytics.types';

/**
 * Fetches chart data from the analytics API
 */
export async function fetchChartData({
    chartType,
    dayRange,
    endDate,
    periodLength,
    showSumSeries = false,
}: FetchChartDataParams): Promise<ChartData> {
    const response = await mainApi.get(`v1/analytics/chart/${chartType}`, {
        params: {
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            day_range: dayRange,
            end_date: endDate,
            ...(periodLength && { period_length: periodLength }),
            ...(showSumSeries && { show_sum_series: 1 }),
        },
    });
    return response.data;
}

/**
 * Consolidated function to fetch chart data by type
 * Replaces multiple wrapper API calls with a single, flexible function
 */
export async function fetchChartDataByType(
    chartTypes: ChartType[],
    dayRange: number,
    endDate: number,
    periodLength?: number,
    showSumSeries = false
): Promise<Record<string, ChartData>> {
    const requests = chartTypes.map(type =>
        fetchChartData({
            chartType: type,
            dayRange,
            endDate,
            periodLength,
            showSumSeries,
        })
    );

    const responses = await Promise.all(requests);

    const data: Record<string, ChartData> = {};
    responses.forEach((response, index) => {
        const chartType = chartTypes[index];
        if (chartType) {
            data[chartType] = response;
        }
    });

    return data;
}
